/** @format */

import React from 'react';
import FeatureProcess from '../../components/process';

export default function ProcessPg(props) {
  return <FeatureProcess />;
}
